"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class EnumDisplay extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "EnumDisplay";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/enum-displays"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create enum display.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    console.error("Cannot update enum displays.");
  }

  getAdminPath() {
    console.error("Cannot go to an enum display.");
  }

  get searchResultTitle() {
    return this.displayName;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default EnumDisplay;
